import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as FellowshipActions from "../../../actions/fellowship";
import * as NavigationActions from "../../../actions/navigation";
import * as PersonnelActions from "../../../actions/personnel";
import { NotificationAlert } from "../../../components/common/index";
import {
    DatePickerFormInputFabric,
    TextAreaFormInput,
    ValidationMessage,
} from "../../../components/form";
import {
    CheckboxFormInput,
    SelectFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { FileUploadFormInput } from "../../../components/form/inputs/FileUploadFormInput";
import { SOURCE_DOCUMENT_UPLOAD_VIEW } from "../../../components/form/inputs/FileUploadFormInput/FileUploadViews";
import { RestrictedLayout } from "../../../components/layouts";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { GridRemove } from "../../../enumerations/GridRemove";
import { RequestState } from "../../../enumerations/RequestState";
import { createPersonnelSearchLoader } from "../../../functions/personnel";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { FellowshipCreateBreadcrumbs, FellowshipDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SOURCE_DOCUMENT_FILE_CONFIGURATION } from "../../../helpers/file";
import {
    getFormPropertyLabel,
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { FellowshipSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IFellowshipReduxFormState } from "../../../reducers/reactReduxForms/fellowship";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { initialSourceDocumentState } from "../../../reducers/reactReduxForms/sourceDocument";
import { requiredSourceDocument, requiredText } from "../../../validators";

import "./FellowshipPage.scss";

interface FellowshipPageProps {
    form: Dtos.Fellowship & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IFellowshipReduxFormState;
    personnel: Dtos.Personnel;
    fellowship: Dtos.Fellowship;
    lookups: Dtos.Lookup[];
    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;
    loadPersonnelErrorCode: string;
    loadingFellowship: boolean;
    loadFellowshipSuccess: boolean;
    loadFellowshipFailure: boolean;
    loadFellowshipErrorCode: string;
    savingFellowship: boolean;
    saveFellowshipSuccess: boolean;
    saveFellowshipFailure: boolean;
    creatingFellowship: boolean;
    createFellowshipSuccess: boolean;
    createFellowshipFailure: boolean;
    validatingFellowship: boolean;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearFellowship: FellowshipActions.IFellowshipClearActionCreator;
    loadFellowship: FellowshipActions.IFellowshipLoadByIdActionCreator;
    saveFellowship: FellowshipActions.IFellowshipSaveActionCreator;
    createFellowship: FellowshipActions.IFellowshipCreateActionCreator;
    validateFellowship: FellowshipActions.IFellowshipValidateActionCreator;
    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.fellowship";

const FellowshipPage: FC<FellowshipPageProps> = ({
    form,
    formState,
    formProperties,
    //reduxFormState,
    personnel,
    fellowship,
    lookups,
    loadingPersonnel,
    //loadPersonnelSuccess,
    loadPersonnelFailure,
    loadPersonnelErrorCode,
    loadingFellowship,
    //loadFellowshipSuccess,
    loadFellowshipFailure,
    loadFellowshipErrorCode,
    savingFellowship,
    saveFellowshipSuccess,
    saveFellowshipFailure,
    creatingFellowship,
    //createFellowshipSuccess,
    //createFellowshipFailure,
    validatingFellowship,
    validationFailures,
    permissions,
    clearFellowship,
    loadFellowship,
    saveFellowship,
    createFellowship,
    validateFellowship,
    clearPersonnel,
    loadPersonnel,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { personnelId } = useParams<{ personnelId: string }>();
    const { fellowshipId } = useParams<{ fellowshipId: string }>();
    const personnelIdNumber = parseInt(personnelId, 10);
    const fellowshipIdNumber = parseInt(fellowshipId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.Fellowship = {} as Dtos.Fellowship;

        loadForm(reduxFormName, Object.assign({ ...fellowship }, extraData));
    };


    // Load fellowship
    useEffect(() => {
        if (fellowshipIdNumber && !fellowship && !loadingFellowship) {
            setDrawerItems(FellowshipSubMenu(personnelIdNumber, fellowshipIdNumber, permissions));
            setBreadcrumbs(FellowshipDetailsBreadcrumbs(personnelIdNumber, fellowshipIdNumber, null));
            loadFellowship(fellowshipIdNumber);
        } 
        else if (!fellowshipIdNumber && !fellowship && !creatingFellowship) {
            createFellowship(personnelIdNumber);
            setBreadcrumbs(FellowshipCreateBreadcrumbs(personnelIdNumber));
            setDrawerItems([]);
        } 
        else if (fellowship && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        fellowshipIdNumber,
        fellowship,
        loadingFellowship,
        personnelIdNumber,
        permissions,
        creatingFellowship,
        initalised
    ]);

    // Load Personnel
    useEffect(() => {
        if (personnelIdNumber && !personnel && !loadingPersonnel) {
            loadPersonnel(personnelIdNumber);
        }
    }, [personnelIdNumber, personnel, loadingPersonnel]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadFellowshipFailure) {
            navigate(`/error/${loadFellowshipErrorCode}`);
        }
        if (loadPersonnelFailure) {
            navigate(`/error/${loadPersonnelErrorCode}`);
        }
    }, [
        loadFellowshipFailure,
        loadFellowshipErrorCode,
        loadPersonnelFailure, 
        loadPersonnelErrorCode
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (fellowshipIdNumber && personnelIdNumber && personnel) {
            setBreadcrumbs(
                FellowshipDetailsBreadcrumbs(
                    personnelIdNumber,
                    fellowshipIdNumber,
                    personnel.displayWithSalutation
                )
            );
        }
        else if (!fellowshipIdNumber && personnelIdNumber && personnel) {
            setBreadcrumbs(
                FellowshipCreateBreadcrumbs(
                    personnelIdNumber,
                    personnel.displayWithSalutation
                )
            );
        }
    }, [fellowshipIdNumber, personnelIdNumber, personnel]);

    // Reload fellowship after saving
    useEffect(() => {
        if (!savingFellowship && saveFellowshipSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Fellowship saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/personnel/${personnelIdNumber}/details`);
            } 
            else if (!personnelIdNumber) {
                navigate(`/personnel/${personnelIdNumber}/fellowship/${fellowship.id}/details`);
                clearFellowship();
            }
        }
    }, [
        savingFellowship,
        saveFellowshipSuccess,
        saveAndReturn,
        fellowship,
        personnelIdNumber
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingFellowship && saveFellowshipFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingFellowship, saveFellowshipFailure]);

    // Cleanup effect to clear the fellowship on component unmount
    useEffect(() => {
        return () => {
            clearFellowship();
            clearPersonnel();
            resetForm(reduxFormName);
        };
    }, [clearFellowship, clearPersonnel, resetForm, reduxFormName]);

    const onCancel = () => {
        navigate(`/personnel/${personnelIdNumber}/details`);
    };

    const handleOnSubmitFailed = (_data: Dtos.Fellowship) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.Fellowship = {} as Dtos.Fellowship;

            await saveFellowship(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.Fellowship = {} as Dtos.Fellowship;

            if (form && hasBeenSubmitted && !validatingFellowship) {
                await validateFellowship(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const personnelSearchLoader = useMemo(() => {
        return createPersonnelSearchLoader(
            form?.supervisor 
                ? { label: form?.supervisor?.displayWithSalutation, value: form?.supervisorId } as Dtos.PersonnelOption 
                : null
        );
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.FellowshipUpdate,
                Dtos.Permission.FellowshipCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingFellowship ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);
        const fileTypeId = lookups
            ?.find((item) => item.propertyName === "FileType")
            ?.values?.find((item) => item.value === "Other")?.id;

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            fellowGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Fellow</h1>
                        <div className="card card-shadow">
                            <div className="form-row py-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            fellowId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: true,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-9 generic-form-field",
                                                inputProps: {
                                                    value: form?.fellow?.displayWithSalutation ?? "",
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            fellowOrganisation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: true,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-9 generic-form-field",
                                                inputProps: {
                                                    value: form?.fellow?.personnelAddresses?.[0]?.companyName,
                                                },
                                                inputLabel: "Organisation",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            projectGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Project Title</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            projectTitle: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            supervisorGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Supervisor</h1>
                        <div className="card card-shadow">
                            <div className="form-row py-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            supervisorId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                size: 2,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    value: form?.supervisorId ?? null,
                                                    cacheOptions: true,
                                                    defaultOptions: form?.supervisor
                                                        ? [{ label: form.supervisor.displayWithSalutation, value: form.supervisor.id }]
                                                        : true,
                                                    placeholder: "Type to search for personnel...",
                                                    clearable: true,
                                                    loadOptions: personnelSearchLoader,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-9 generic-form-field pl-4 mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            supervisorOrganisation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: true,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-9 generic-form-field",
                                                inputProps: {
                                                    value: form?.supervisorId == form?.supervisor?.id ? form?.supervisor?.personnelAddresses?.[0]?.companyName : "",
                                                },
                                                inputLabel: "Organisation",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            statusGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Status</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateEntered: {
                                                type: RegistrationComponent.RegistrationControl,
                                                validationMessageAbove: true,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: true,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            awarded: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Awarded Fellowship",
                                                },
                                                inputLabel: " ",
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-7 generic-form-field d-flex align-items-center pt-2",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateStart: {
                                                type: RegistrationComponent.RegistrationControl,
                                                validationMessageAbove: true,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateExpectedCompletion: {
                                                type: RegistrationComponent.RegistrationControl,
                                                validationMessageAbove: true,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row px-4 py-2">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateSixMonthReportDue: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                validationMessageAbove: true,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateSixMonthReportReceived: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                validationMessageAbove: true,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateFinalOutcomeReportDue: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                validationMessageAbove: true,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            dateFinalOutcomeReportReceived: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                validationMessageAbove: true,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            disciplineGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Discipline</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            disciplineId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                size: 2,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "Fellowship",
                                                                "disciplineId",
                                                                lookups
                                                            ),
                                                            form.disciplineId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            documentsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Documents</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "fellowship",
                                        {
                                            sourceDocumentForm: {
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: " ",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName: "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className: "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "15%",
                                                                minWidth:
                                                                    "100px",
                                                            },
                                                            {
                                                                width: "15%",
                                                                minWidth:
                                                                    "100px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig: GridRemove.All,
                                                        addRow: (gridComponent, _index, _array) => {
                                                            const state: Dtos.SourceDocument = Object.assign({...gridComponent.initialState});
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType: TextFormInput,
                                                                inputDisabled: formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Fellowship",
                                                                        "Document Name",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon: FontAwesomeIcons.Solid.BAN,
                                                                },
                                                                validators: {
                                                                    required: requiredText,
                                                                },
                                                                errors: {
                                                                    required: "Document name is required.",
                                                                },
                                                                errorComponent: ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType: FileUploadFormInput,
                                                                inputDisabled: formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Fellowship",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (model, value, form, parentModel) => {
                                                                    changeForm(model, value);
                                                                    changeForm(reduxFormName + parentModel + ".fileType", fileTypeId);
                                                                    const inputValue: Dtos.TemporaryFileInformation = value;
                                                                    const sourceDocument: Dtos.SourceDocument = form;
                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument.fileInformation.state != inputValue.state &&
                                                                        inputValue.state == Dtos.FileState.Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(reduxFormName + parentModel + ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue.temporaryFile.extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required: requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required: "File must be uploaded.",
                                                                },
                                                                errorComponent: ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    changeForm(model + "active", false);
                                                    return true; // this was handled here
                                                },
                                                filterRow: (data: Dtos.SourceDocument) => {
                                                    return data.active;
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "fellowship",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary mr-2"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        form,
        permissions,
        savingFellowship,
        formState,
        lookups,
        lookups,
        validationFailures,
        formProperties,
        changeForm,
        personnelSearchLoader,
        generateOptionsFromLookup,
        findLookup,
        getFormPropertyLabel,
        reduxFormName,
        handleOnSubmit,
        handleOnSubmitFailed,
        onCancel
    ]);

    return (
        <RestrictedLayout
            loading={
                loadingFellowship || 
                creatingFellowship || 
                loadingPersonnel
            }
            permission={Dtos.Permission.FellowshipView}
        >
            { renderContent }
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<FellowshipPageProps> => {
    let fellowship: Dtos.Fellowship | undefined = !(state.fellowships.formData instanceof Array)
        ? state.fellowships.formData
        : undefined;
    let personnel: Dtos.Personnel | undefined = !(state.personnel.formData instanceof Array)
        ? state.personnel.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        fellowship: fellowship!,
        personnel: personnel!,

        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,
        loadPersonnelErrorCode: state.personnel.loadState.errorCode,

        loadingFellowship:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Pending,
        loadFellowshipSuccess:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Success,
        loadFellowshipFailure:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Failure,
        loadFellowshipErrorCode: state.fellowships.loadState.errorCode,

        savingFellowship:
            state.fellowships.saveState &&
            state.fellowships.saveState.status == RequestState.Pending,
        saveFellowshipSuccess:
            state.fellowships.saveState &&
            state.fellowships.saveState.status == RequestState.Success,
        saveFellowshipFailure:
            state.fellowships.saveState &&
            state.fellowships.saveState.status == RequestState.Failure,

        creatingFellowship:
            state.fellowships.createState &&
            state.fellowships.createState.status == RequestState.Pending,
        createFellowshipSuccess:
            state.fellowships.createState &&
            state.fellowships.createState.status == RequestState.Success,
        createFellowshipFailure:
            state.fellowships.createState &&
            state.fellowships.createState.status == RequestState.Failure,

        validatingFellowship:
            state.fellowships.validateState &&
            state.fellowships.validateState.status == RequestState.Pending,

        permissions: permissions,
        lookups: state.fellowships.lookups,

        form: state.reduxForms.fellowship,
        formState: state.fellowships.formState,
        formProperties: state.fellowships.formProperties,

        reduxFormState: state.reduxForms.formState.fellowship,
        validationFailures: fellowship
            ? state.fellowships.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<FellowshipPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadFellowship: bindActionCreators(FellowshipActions.LoadFellowshipById, dispatch),
        clearFellowship: bindActionCreators(FellowshipActions.Clear, dispatch),

        loadPersonnel: bindActionCreators(PersonnelActions.LoadPersonnelById, dispatch),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),

        saveFellowship: bindActionCreators(FellowshipActions.SaveFellowship, dispatch),
        createFellowship: bindActionCreators(FellowshipActions.CreateFellowship, dispatch),
        validateFellowship: bindActionCreators(FellowshipActions.ValidateFellowship, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default connect(mapStateToProps,  mapDispatchToProps)(FellowshipPage);
